import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import UserIcon from "@material-ui/icons/Person";
import useStyles from "./styles/finish";
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import { useDataSync } from "../../../components/PouchDB/DataSyncProvider";
import { useSnackbar } from "notistack";
import { countAge } from "./pk/validation";
import lodashGet from "lodash/get";
import SaveIcon from "@material-ui/icons/Save";
import MapIcon from "@material-ui/icons/Map";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";
import axios from "axios";
/*---map---*/
import { useMediaQuery } from "react-responsive";
import GoogleMapReact from "google-map-react";
import {
  MapContainer as LeafletMap,
  TileLayer,
  Marker,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconMarker from "../../../images/marker_red.png";
import Swal from "sweetalert2";
/*---end map---*/

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import { renderDataKK, renderDataNIK } from "./preview";
import BlockUi from "react-block-ui";
import LocationIcon from "@material-ui/icons/LocationOnOutlined";

function Finish({
  wilayah,
  keluarga,
  normalizePK,
  normalizeKB,
  resetForm,
  mode,
  no_kk,
  pus,
  kb,
  pusLainnya,
  pertanyaanPus,
  hamilPertama,
  hamilPertamaLainnya,
  jmlHamilLainnya,
}) {
  const classes = useStyles();
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const NEW_URL = process.env.REACT_APP_API_CONFIG_URL_NEW;
  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  const { enqueueSnackbar } = useSnackbar();
  const {
    user: { metadata },
    dataKK,
    dataPK,
    dataKB,
    dataBkkbn,
  } = usePouchDB();
  const { manualSync } = useDataSync();
  const [lcu, setlcu] = useState([]);
  const [expanded, setExpanded] = useState("panel1a");

  const [isSubmitting, setSubmitting] = useState({
    local: false,
    remote: false,
  });

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [flagButton, setflagButton] = useState(false);
  const [disButtonLokasi, setDisButtonLokasi] = useState(false);

  const [lock, setLock] = useState(localStorage.getItem("lock"));

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [lockTarget, setLockTarget] = useState(
    localStorage.getItem("lockTarget")
  );
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );

  /*-----map-----*/
  const AnyReactComponent = ({ text }) => <div>{text}</div>;
  const [openMap, setOpenMap] = useState(false);
  const [center, setCenter] = useState({ lat: -6.2876404, lng: 106.8117842 });
  const [zoom, setZoom] = useState(15);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const markerRef = React.useRef(null);

  let markIcon = L.icon({
    iconUrl: iconMarker,
    iconRetinaUrl: iconMarker,
    iconAnchor: [5, 35],
    popupAnchor: [10, -44],
    iconSize: [25, 35],
  });

  const handleMaps = () => {
    if (
      wilayah.sts_keluarga === "2" ||
      wilayah.sts_keluarga === "3" ||
      wilayah.sts_keluarga === "4" ||
      wilayah.sts_keluarga === "5"
    ) {
      // console.log('exception 2,3,4,5 run...')
      (async () => await saveTo(null, "remote"))();
    } else {
      setflagButton(true);
      setSubmitting({
        local: true,
        remote: true,
      });
      navigator.geolocation.getCurrentPosition(success, error);
    }
  };

  const success = (position) => {
    console.log("run success");
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude : ", position.coords.latitude);
        console.log("Longitude : ", position.coords.longitude);
        console.log(wilayah.location, "location wilayah");
        let ltd = position.coords.latitude;
        let lon = position.coords.longitude;
        if (
          wilayah.location &&
          wilayah.location.locationUser.length > 0 &&
          wilayah.location.locationUser[0].latitude !== 0 &&
          wilayah.location.locationUser[1].longitude !== 0
        ) {
          ltd = wilayah.location.locationUser[0].latitude;
          lon = wilayah.location.locationUser[1].longitude;
        }
        setlcu([
          {
            latitude: ltd,
          },
          {
            longitude: lon,
          },
        ]);
        setCenter({ lat: ltd, lng: lon });
        setOpenMap(true);
      });
    } else {
      console.log("Geo Location Off!!!");
    }
  };

  const error = () => {
    Swal.fire({
      title: "Peringatan",
      icon: "warning",
      text: "Silakan cek pengaturan perizinan lokasi pada browser anda. Anda dapat melakukan submit form setelah memberikan izin aplikasi untuk mengakses lokasi anda.",
    });
  };

  const eventHandlers = React.useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          const lat = marker.getLatLng().lat;
          const lng = marker.getLatLng().lng;
          console.log(lat, lng, "lat lng");
          setCenter({ lat: lat, lng: lng });
          setlcu([
            {
              latitude: lat,
            },
            {
              longitude: lng,
            },
          ]);
        }
      },
    }),
    []
  );

  const loadMap = (map, maps) => {
    console.log("run load map");
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude : ", position.coords.latitude);
        console.log("Longitude : ", position.coords.longitude);
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        let marker = new maps.Marker({
          position: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
          icon: iconMarker,
          map,
          draggable: true,
        });

        marker.setPosition(map.getCenter());
        marker.addListener("dragend", () => {
          console.log(marker.getPosition().lat());
          console.log(marker.getPosition().lng());
          map.setCenter(marker.getPosition());
        });
      });
    } else {
      console.log("Geo Location Off!!!");
    }
  };

  const handleCloseMap = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setOpenMap(false);
    setflagButton(false);
    setSubmitting({
      local: false,
      remote: false,
    });
  };
  /*-----end map----*/

  const getlcu = () => {
    const lockTarget = localStorage.getItem("lockTarget");
    const lockWilayah = localStorage.getItem("lockWilayah");
    setLockTarget(lockTarget);
    setLockWilayah(lockWilayah);

    // try {
    //     if (lcu.length < 0) {
    //         console.log("Not Run Lokasi if")
    //         Swal.fire({
    //             title: 'Gagal',
    //             icon: 'warning',
    //             text: 'Lokasi tidak ditemukan, silakan aktifkan lokasi pada perangkat anda dan coba lagi.',
    //             cancelButtonColor: '#d33',
    //             confirmButtonText: 'YA',
    //             confirmButtonColor: '#3085d6',
    //             // showCancelButton: true,
    //             // cancelButtonText: 'Batal',
    //         })
    //     } else if (navigator.geolocation) {
    //         console.log("Run Lokasi if")
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             console.log("Latitude xxx: ", position.coords.latitude)
    //             console.log("Longitude xxx: ", position.coords.longitude)
    //             setlcu([{
    //                 'latitude': position.coords.latitude
    //             }, {
    //                 'longitude': position.coords.longitude
    //             }]);
    //         });
    //     }
    // } catch (error) {
    //     console.log(error);
    // }

    if (navigator.geolocation) {
      console.log("Run Lokasi if");
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude xxx: ", position.coords.latitude);
        console.log("Longitude xxx: ", position.coords.longitude);
        setlcu([
          {
            latitude: position.coords.latitude,
          },
          {
            longitude: position.coords.longitude,
          },
        ]);
      });
    } else {
      console.log("Not Run Lokasi if");
    }
  };

  useEffect(() => {
    getlcu();
  }, []);

  const tanggal = new Date();
  const timestamp = tanggal.getTime();
  let data_cfm = false;

  const insertNotif = (id) => {
    let userInsert = metadata.name;
    let userDataInsert = 7;

    // fetch('https://demo-bkkbn-notif.herokuapp.com/api/v1/pushnotification', {
    // fetch('http://web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {

    fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
      // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
      // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        _id: id,
        username: userInsert,
        statusData: userDataInsert,
      }),
    })
      .then((respone) => {
        respone.json();
      })
      .then((data) => {})
      .catch((e) => console.error(e));
  };

  const updateNotif = (id) => {
    let userUpdate = metadata.name;
    let userDataUpdate = 8;
    // fetch('https://demo-bkkbn-notif.herokuapp.com/api/v1/pushnotification', {
    // fetch('http://web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {

    // fetch("https://webpushnotif-dev.bkkbn.go.id/api/v1/pushnotification", {
    //   // fetch('https://webpushnotif.bkkbn.go.id/api/v1/pushnotification', {
    //   // fetch('http://dev-web-push-notification-service-bkkbn.apps.tkp.platform.lintasarta.net/api/v1/pushnotification', {
    //   method: "POST",
    //   headers: { "Content-type": "application/json" },
    //   body: JSON.stringify({
    //     _id: id,
    //     username: userUpdate,
    //     statusData: userDataUpdate,
    //   }),
    // })
    //   .then((respone) => {
    //     respone.json();
    //   })
    //   .then((data) => {})
    //   .catch((e) => console.error(e));
  };

  // const saveTo = target => async (e) => {
  const saveTo = async (e, target) => {
    // console.log(true);

    if (e) {
      e.stopPropagation();
    }
    // console.log("save to run...");
    setflagButton(true);
    setDisButtonLokasi(true);

    // put data utama to KK
    let create_id = `${Date.now().toString()}${metadata.name}`;

    let locationUser = [
      {
        latitude: 0,
        longitude: 0,
      },
    ];

    try {
      if (lcu.length !== 0) {
        locationUser = [
          {
            latitude: lcu[0].latitude,
            longitude: lcu[1].longitude,
          },
        ];
      } else if (
        localStorage.getItem("xsLocUser") !== null &&
        localStorage.getItem("xsLocUser").length !== 0
      ) {
        const locArr = JSON.parse(localStorage.getItem("xsLocUser"));
        locationUser = [
          {
            latitude: locArr[0].latitude,
            longitude: locArr[1].longitude,
          },
        ];
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(locationUser, "locationUser");

    let os = window.navigator.userAgent;
    let time = new Date()
      .toLocaleString()
      .replace(",", "")
      .replace(/:.. /, " ");

    // console.log("metadata>>>", metadata);
    // console.log("id>>>", create_id);

    const dataKKUtama = {
      // _id: wilayah.no_kk,
      _id: create_id,
      user_name: metadata.nameProses,
      id_prov: parseInt(metadata.wil_provinsi.id_provinsi),
      id_prov_depdagri: parseInt(metadata.wil_provinsi.id_provinsi_depdagri),
      id_kab: parseInt(metadata.wil_kabupaten.id_kabupaten),
      id_kab_depdagri: parseInt(metadata.wil_kabupaten.id_kabupaten_depdagri),
      id_kec: parseInt(metadata.wil_kecamatan.id_kecamatan),
      id_kec_depdagri: parseInt(metadata.wil_kecamatan.id_kecamatan_depdagri),
      id_kel: parseInt(metadata.wil_kelurahan.id_kelurahan),
      id_kel_depdagri: parseInt(metadata.wil_kelurahan.id_kelurahan_depdagri),
      ...wilayah,
      id_rw: wilayah.id_rw,
      id_rt: wilayah.id_rt,
      id_rw_bkkbn: wilayah.id_rw_bkkbn,
      id_rt_bkkbn: wilayah.id_rt_bkkbn,
      klasifikasiDesa: metadata.wil_kelurahan.klasifikasiDesa || "",
      lokus_verval_pk25: metadata.wil_kelurahan.lokus_verval_pk25 || "",
      cfm: wilayah.cfm || false,
      audit_trail: "Insert From " + os + " At " + time,
      location: { locationUser },
    };

    const data_nik = Object.keys(keluarga).map((_id) => {
      return {
        ...keluarga[_id],
        sts_hubungan: parseInt(keluarga[_id].sts_hubungan),
        sts_kawin: parseInt(keluarga[_id].sts_kawin),
        jns_pendidikan: parseInt(keluarga[_id].jns_pendidikan),
        jns_asuransi: parseInt(keluarga[_id].jns_asuransi),
        id_agama: parseInt(keluarga[_id].id_agama),
        jenis_pekerjaan: parseInt(keluarga[_id].jenis_pekerjaan),
        sts_pekerjaan: parseInt(keluarga[_id].sts_pekerjaan),
        mutasi_anggota_keluarga:
          parseInt(keluarga[_id].mutasi_anggota_keluarga) || null,
        usia_kawin:
          parseInt(keluarga[_id].sts_kawin) === 1
            ? 0
            : parseInt(lodashGet(keluarga[_id], "usia_kawin", 0)),
        // sts_hubanak_ibu: parseInt(lodashGet(keluarga[_id], 'sts_hubanak_ibu', 0)),
        kd_ibukandung: parseInt(lodashGet(keluarga[_id], "kd_ibukandung", 0)),
        umur: countAge(keluarga[_id].tgl_lahir),
        // keberadaan: parseInt(lodashGet(keluarga[_id], 'keberadaan', 0)),
      };
    });
    //simpan ke db local
    setSubmitting((curr) => ({ ...curr, [target]: true }));

    let data_pk = Object.values(normalizePK);
    let data_kb = Object.values(normalizeKB);
    // console.log("data kb>>>> ", data_kb);

    // let data_pus = []
    // let data_pus_lainnya = []
    // let hamil_pertama_pus_lainnya = ''
    // let jumlah_keluarga_pus_lainnya = ''

    // console.log("keluargaaa", Object.values(keluarga));

    const findWife = Object.values(keluarga).find((k) => {
      if (
        k.jenis_kelamin === "2" &&
        (k.sts_kawin === "2" || k.sts_kawin === "3") &&
        k.sts_hubungan === "2"
      ) {
        const age = countAge(k.tgl_lahir);
        return age >= 10 && age <= 49;
      }
      return false;
    });

    // console.log("istriiiiiii", findWife);

    if (mode == "edit") {
      if (Object.values(normalizePK).length == 0) {
        data_pk = wilayah.data_pk;
      }

      // if (pertanyaanPus == "1") {
      //     //Istri hamil atau memiliki anak
      //     if (Object.values(pus).length > 0) {
      //         data_pus = Object.values(pus);
      //     }

      //     if (hamilPertamaLainnya == "1") {
      //         data_pus_lainnya = Object.values(pusLainnya);
      //     }

      //     hamil_pertama_pus_lainnya = hamilPertamaLainnya
      //     jumlah_keluarga_pus_lainnya = jmlHamilLainnya
      // }

      if (keluarga["1"].sts_kawin == "2" || keluarga["1"].sts_kawin == "3") {
        //jika dia memiliki istri
        if (findWife) {
          if (normalizeKB == "") {
            data_kb = wilayah.data_kb;
          }
        } else {
          data_kb = Object.values("");
        }
      } else {
        data_kb = Object.values("");
      }
    } else {
      // if (pertanyaanPus == "1") {
      //     //Istri hamil atau memiliki anak
      //     if (Object.values(pus).length > 0) {
      //         data_pus = Object.values(pus);
      //     }
      //     if (hamilPertamaLainnya == "1") {
      //         data_pus_lainnya = Object.values(pusLainnya);
      //     }
      //     hamil_pertama_pus_lainnya = hamilPertamaLainnya
      //     jumlah_keluarga_pus_lainnya = jmlHamilLainnya
      // }
    }

    // const data_kb = Object.values(normalizeKB);
    //const data_pk = Object.values(normalizePK);
    const status_draft = "2";
    const pos_draft = "";
    const subformIndex = "0";
    const form_invalid = "";
    const index_invalid = "";
    // const pertanyaan_pus = pertanyaanPus
    const created = Date.now();
    const last_update = Date.now();
    // for audit_trail
    // let os = window.navigator.userAgent; //get Browser and Os Version
    // let time = new Date()
    //   .toLocaleString()
    //   .replace(",", "")
    //   .replace(/:.. /, " ");

    //console.log("audit_trail => ", action + " from : " + os + " at : " + time)

    //perubahan baru
    let dataBkkbnAll = {
      ...dataKKUtama,
      periode_sensus: "2025",
      status_sensus: "",
      group: "dataBkkbn",
      submit: true,
      data_nik,
      data_kb,
      data_pk,
      // pertanyaan_pus,
      // hamil_pertama_pus_lainnya,
      // jumlah_keluarga_pus_lainnya,
      // data_pus,
      // data_pus_lainnya,
      status_draft,
      pos_draft,
      subformIndex,
      last_update,
      form_invalid,
      index_invalid,
    };
    // console.log("dataBkkbnAll user_name=> ", dataBkkbnAll.user_name);

    let dataToSave = { ...dataBkkbnAll };
    let dataToSaveLocal;

    if (mode !== "edit") {
      //05Des2019
      const audit_trail = "Insert From " + os + " At " + time;

      dataToSave = {
        ...dataBkkbnAll,
        created,
        audit_trail,
      };

      dataToSaveLocal = {
        ...dataBkkbnAll,
        sts_keluarga: wilayah.sts_keluarga,
        audit_trail: "Insert From " + os + " At " + time,
        status_sensus: "Tersimpan",
        flag_retrieve: "",
      };
    }

    try {
      if (mode === "edit") {
        // const kkDoc = await dataBkkbn.remote.get(wilayah._id);
        const data_selector = {
          selector: {
            _id: wilayah._id,
          },
          limit: 10000,
        };
        const idkec = metadata?.wil_kecamatan?.id_kecamatan;

        // const kkDoc = await axios.post(
        //   url +
        //     "/_find?couchdb=" +
        //     couchdb +
        //     "&database-name=" +
        //     db_name +
        //     "&idKec=" +
        //     idkec,
        //   data_selector,
        //   {
        //     // headers: { user_key: USER_KEY_PG }
        //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        //   }
        // );

        //await dataBkkbn.remote.put({ ...kkDoc, _deleted: true });

        // console.log("get remot => ", kkDoc._rev)
        // console.log("kkDoc => ", kkDoc.data[0])

        // const kDoc = kkDoc.data[0];
      }

      //insert to server
      // console.log("data bkkbn all ", dataToSave)
      // await dataBkkbn[target].put(dataToSave);

      // await axios.put(
      //   url +
      //     "/" +
      //     dataToSave._id +
      //     "/_put?couchdb=" +
      //     couchdb +
      //     "&database-name=" +
      //     db_name +
      //     "&_id=" +
      //     dataToSave._id +
      //     "&idKec=" +
      //     metadata?.wil_kecamatan?.id_kecamatan,
      //   dataToSave,
      //   {
      //     // headers: { user_key: USER_KEY_PG }
      //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
      //   }
      // );
      // console.log("aaaaaaaaaaaaa", dataToSave);

      await axios
        .post(
          NEW_URL +
            "pk/api/v1/getPkByIdfrm?idfrm=" +
            dataToSave._id +
            "&username=" +
            dataToSave.user_name,
          {},
          { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
        )
        .then(async (res) => {
          // console.log("aaaaaaaaaaaaaaaaa", res.data);
          let os = window.navigator.userAgent;
          let time = new Date()
            .toLocaleString()
            .replace(",", "")
            .replace(/:.. /, " ");
          let audit_trail;

          if (mode === "edit") {
            audit_trail = "Update From " + os + " At " + time;
            dataToSave = {
              ...dataBkkbnAll,
              _rev: res.data.data[0]._rev,
              status_sensus: "",
              sts_keluarga: wilayah.sts_keluarga,
              audit_trail,
            };
          } else {
            audit_trail = "Insert From " + os + " At " + time;
            dataToSave = {
              ...dataBkkbnAll,
              status_sensus: "",
              sts_keluarga: wilayah.sts_keluarga,
              audit_trail,
            };
          }
          // console.log("data>>>>>", dataToSave);
          // console.log("save local", dataToSaveLocal);

          try {
            await axios.post(NEW_URL + "pk/api/v1/save", dataToSave, {
              headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
            });
          } catch (error) {
            console.error("Error saat insert data:", error);
          }
        })
        .catch((error) => console.log("Error:", error));

      // await axios
      //   .post(NEW_URL + "pk/api/v1/save", dataToSave)
      //   .then((res) => console.log(res))
      //   .catch((err) => {
      //     console.error("Error saving data to remote: ", err);
      //   });
      //end insert

      if (mode !== "edit") {
        try {
          // const cek = await dataBkkbn.remote.get(create_id);
          // const data_selector = {
          //   selector: {
          //     _id: create_id,
          //   },
          //   limit: 10000,
          // };
          // const idkec = metadata?.wil_kecamatan?.id_kecamatan;

          // const cek = await axios.post(
          //   url +
          //     "/_find?couchdb=" +
          //     couchdb +
          //     "&database-name=" +
          //     db_name +
          //     "&idKec=" +
          //     idkec,
          //   data_selector,
          //   {
          //     // headers: { user_key: USER_KEY_PG }
          //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          //   }
          // );

          // const cek = await axios
          //   .post(
          //     NEW_URL +
          //       "pk/api/v1/getPkByIdfrm?idfrm=" +
          //       dataToSave._id +
          //       "&username=" +
          //       dataToSave.user_name,
          //     {},
          //     { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
          //   )
          //   .then(async (res) => {
          //     let os = window.navigator.userAgent;
          //     let time = new Date()
          //       .toLocaleString()
          //       .replace(",", "")
          //       .replace(/:.. /, " ");
          //     const insertData = {
          //       ...dataBkkbnAll,
          //       status_sensus: "",
          //       sts_keluarga: wilayah.sts_keluarga,
          //       audit_trail: "Insert From " + os + " At " + time,
          //       _rev: res.data.data[0]._rev,
          //     };
          //     console.log("insertData => ", insertData);

          //     // try {
          //     //   await axios.post(NEW_URL + "pk/api/v1/save", insertData, {
          //     //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          //     //   });
          //     // } catch (error) {
          //     //   console.error("Error saat insert data:", error);
          //     // }

          //   })
          //   .catch((error) => console.log("Error:", error));
          // if (cek) {
          //   await dataBkkbn["local"].put(dataToSaveLocal);
          // } else {
          dataToSaveLocal = {
            ...dataToSave,
            status_sensus: "",
            flag_retrieve: "",
          };

          if (mode === "edit") {
            const query = await dataBkkbn.local.find({
              selector: {
                _id: { $eq: dataToSave._id },
              },
            });

            const _rev = query.docs.length > 0 ? query.docs[0]._rev : null;

            const audit_trail = "Update From " + os + " At " + time;
            dataToSave = {
              ...dataBkkbnAll,
              _rev,
              status_sensus: "",
              sts_keluarga: wilayah.sts_keluarga,
              audit_trail,
            };
          } else {
            const audit_trail = "Insert From " + os + " At " + time;
            dataToSave = {
              ...dataBkkbnAll,
              status_sensus: "",
              sts_keluarga: wilayah.sts_keluarga,
              audit_trail,
            };
          }
          // console.log("save local", dataToSaveLocal);

          await dataBkkbn["local"].put(dataToSaveLocal);
          // }
        } catch (error) {
          console.log("eror simpan data => ", error);
          dataToSaveLocal = {
            ...dataToSave,
            status_sensus: "",
          };
          await dataBkkbn["local"].put(dataToSaveLocal);
        }
      } else {
        // console.log("data to save local ", dataToSaveLocal)
        await dataBkkbn["local"].put(dataToSaveLocal);
      }

      // manualSync()

      let message =
        mode === "edit"
          ? `Data berhasil diperbarui`
          : `Data berhasil disimpan ke ${target} DB`;
      enqueueSnackbar(message, { variant: "success" });
      handleCloseMap();
      setDisButtonLokasi(false);

      const id = wilayah._id;

      setSubmitting((curr) => ({ ...curr, [target]: false }));
      setSaved((curr) => ({ ...curr, [target]: true }));
      if (mode === "edit") {
        updateNotif(id);
      } else {
        insertNotif(id);
      }
    } catch (e) {
      console.log(true, "error save to remote");

      dataToSaveLocal = {
        ...dataBkkbnAll,
        status_sensus: "",
      };
      //end
      console.log("data to save local if error ", dataToSaveLocal);

      try {
        await dataBkkbn["local"].put(dataToSaveLocal);
      } catch (error) {
        console.log("data error to save local if error ");
      }

      let message =
        mode === "edit"
          ? `Data berhasil diperbarui`
          : `Data berhasil disimpan ke local DB`;
      enqueueSnackbar(message, { variant: "success" });

      setSubmitting((curr) => ({ ...curr, [target]: false }));
      setSaved((curr) => ({ ...curr, [target]: true }));
      //enqueueSnackbar(e.message, { variant: 'error' })
      if (e.message.includes("The database connection is closing")) {
        window.location.href = "/login";
      }

      setDisButtonLokasi(false);
    }
    setOpenMap(false);
    setflagButton(false);
    setSubmitting({
      local: false,
      remote: false,
    });
  };

  //----- Check Network Online state -----//
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen to the online status
    window.addEventListener("online", handleStatusChange);

    // Listen to the offline status
    window.addEventListener("offline", handleStatusChange);

    // Specify how to clean up after this effect for performance improvment
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]);
  //----- End Check Network Online state -----//

  console.log(isOnline, "KONEKSI INTERNET >>>");

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.textCenter}>
          <Typography variant="h5" component="h1">
            {mode === "edit" ? `Preview Edit Data` : "Preview Data"}
          </Typography>
          {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item>
          <Typography className={classes.heading}>
            <LocationIcon />
            <b>Lokasi Pendataan</b>
          </Typography>
        </Grid>

        {/* {lockTarget === 'false' && lockWilayah === 'false' ? (
                    <Grid item>
                        <Button size="small" variant="contained" color="primary" onClick={() => getlcu()}><RefreshIcon className={classes.iconLeft} /></Button>
                    </Grid>
                ) : (
                    <></>
                )} */}

        <Grid item xs={12}>
          <Typography>
            {" "}
            Latitude: {lcu.length > 0 ? lcu[0].latitude : "-"}
          </Typography>
          <Typography>
            {" "}
            Longitude: {lcu.length > 0 ? lcu[1].longitude : "-"}
          </Typography>
          {/* <Typography> Latitude: {lockTarget === 'false' && lockWilayah === 'false' ? wilayah.location.locationUser[0].latitude : lcu.length > 0 ? lcu[0].latitude : "-"}</Typography> */}
          {/* <Typography> Longitude: {lockTarget === 'false' && lockWilayah === 'false' ? wilayah.location.locationUser[1].longitude : lcu.length > 0 ? lcu[1].longitude : "-"}</Typography> */}
        </Grid>
        <Grid item xs={12}>
          <ExpansionPanel
            expanded={expanded === "panel1a"}
            onChange={handleChange("panel1a")}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>Data KK</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {renderDataKK(metadata, wilayah)}
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel
            expanded={expanded === "panel1b"}
            onChange={handleChange("panel1b")}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.heading}>
                Data Anggota Keluarga
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container spacing={2}>
                {Object.values(keluarga).map((kel) => (
                  <Grid key={kel.no_urutnik} item xs={12}>
                    {renderDataNIK(kel)}
                  </Grid>
                ))}
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        {lock === "true" || lockWilayah === "true" ? (
          <></>
        ) : (
          <>
            <Grid item>
              <div className={classes.btnWrap}>
                <Button
                  disabled={isSubmitting.remote || isSaved.remote}
                  // size="large" variant="contained" color="primary" onClick={isOnline ? handleMaps : (e) => saveTo(e, 'remote')}>
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={(e) => saveTo(e, "remote")}
                >
                  {
                    // flagButton ? <> <MapIcon className={classes.iconLeft} /> Loading Maps </> : <> <SaveIcon className={classes.iconLeft} /> {mode === 'edit' ? 'Perbarui' : 'Simpan'} Data </>
                    flagButton ? (
                      <>
                        {" "}
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />{" "}
                        Loading...{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <SaveIcon className={classes.iconLeft} />{" "}
                        {mode === "edit" ? "Perbarui" : "Simpan"} Data{" "}
                      </>
                    )
                  }
                </Button>
                {isSubmitting.local && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </Grid>

            {/* <Grid item>
                        <div className={classes.btnWrap}>
                            <Button
                                onClick={saveTo('local')}
                                disabled={isSubmitting.local || !isSaved.local}
                                size="large" variant="contained"  ><SaveIcon className={classes.iconLeft} />Save as Draft</Button>
                        </div>
                    </Grid> */}

            <Grid item>
              <div className={classes.btnWrap}>
                <Button
                  onClick={resetForm}
                  disabled={isSubmitting.remote || !isSaved.remote}
                  size="large"
                  variant="contained"
                >
                  <UserIcon className={classes.iconLeft} />
                  Isi Data Baru
                </Button>
              </div>
            </Grid>
          </>
        )}
      </Grid>

      <Dialog
        open={openMap}
        onClose={handleCloseMap}
        fullScreen={isTabletOrMobile}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ backgroundColor: "#4CAF50", color: "#fff" }}
        >
          Konfirmasi Lokasi
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span style={{ fontSize: "12px" }}>
              Anda dapat melakukan drag pada marker untuk merubah alamat lokasi.
            </span>
            <div className="mapArea">
              {/* <GoogleMapReact
                                bootstrapURLKeys={{ key: 'AIzaSyAQPZYQaP-CBqN9hEVMXM8DPTDeZZa1-u8' }}
                                center={center}
                                defaultZoom={zoom}
                                yesIWantToUseGoogleMapApiInternals
                                onGoogleApiLoaded={({ map, maps }) => loadMap(map, maps)}
                            ></GoogleMapReact> */}
              <LeafletMap center={center} zoom={zoom} scrollWheelZoom={false}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | BKKBN'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                  draggable={true}
                  eventHandlers={eventHandlers}
                  position={center}
                  ref={markerRef}
                  icon={markIcon}
                ></Marker>
              </LeafletMap>
            </div>
            <div>
              <Button
                disabled={disButtonLokasi}
                onClick={(e) => saveTo(e, "remote")}
                variant="contained"
                fullWidth
                color="primary"
                style={{ borderRadius: "0", color: "white", marginTop: "2px" }}
              >
                Pilih Lokasi
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseMap}
            color="secondary"
            variant="contained"
          >
            <CloseIcon className={classes.iconLeft} />
            Batal
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Finish;
